import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {WritableDraft} from "immer/dist/internal";
import {RootState} from "../../app/store";
import {SliceStatus} from "../BaseState";
import {SearchState} from "./SearchState";

const initialState: SearchState = {
  search: null,
  submitted: null,
  pendings: [],
  status: SliceStatus.idle,
  error: null
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearch: (draft: WritableDraft<SearchState>, action: PayloadAction<string | null>) => {
      draft.search = action.payload;
    },
    submit: (draft: WritableDraft<SearchState>) => {
      draft.submitted = draft.search;
    }
  }
});

export const {setSearch, submit} = searchSlice.actions;
export const searchState = (state: RootState): SearchState => state.search;
export default searchSlice.reducer;
